import MainComponent from "components/Main";
import PropTypes from "prop-types";

import './index.less';

import config from "config";
import SpecItem from "../specItem";


/**
 * Created by viclight on 04.03.2024.
 */
export default class SpecsList extends MainComponent {


    static propTypes = {
        items: PropTypes.array,
        isMedGeneral: PropTypes.bool,
        onChange: PropTypes.func
    };

    static defaultProps = {
        items: [],
        isMedGeneral: false,
        onChange: null
    };


    constructor(props) {
        super(props);

        this.sources = (props.isMedGeneral) ? config.specsMedGeneralList : config.specsStomatList;

    }

    findSpecById(id) {
        let index = this.props.items.findIndex(it => it.id === id);

        if (index >= 0) {
            return true;
        }

        return false;
    }
    render() {

        return (
            <div className="specsList flex wrap">
                {
                    this.sources.map((it)=>{
                        return (<SpecItem item={it} select={this.findSpecById(it.id)} used={this.props.used} key={it.id} onChange={this.props.onChange}/>);
                    })
                }
            </div>
        );
    }

}
